import styled from 'styled-components';
import { layout, media } from 'src/components/base';

export const Header = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: ${layout.measurements.spacing050};
`;

export const SitemapItemList = styled.ul`
  display: grid;
  flex: 1 0 auto;
  grid-template-columns: repeat(auto-fill, minmax(auto, 50%));
  list-style: none;

  ${media.mediumOnly`
    grid-template-columns: repeat(auto-fill, minmax(auto, 33%));
  `}

  ${media.largeUp`
    grid-template-columns: repeat(auto-fill, minmax(auto, 25%));
  `}
`;
